import { useState } from "react"

function getNewSet<T>(x?: T): Set<T> {
  return x === undefined ? new Set() : new Set([x])
}

export function useSetOf<T>(initial: T) {
  const [items, setItems] = useState<Set<T>>(() => getNewSet(initial))

  const setItem = (item: T) => {
    setItems((s) => {
      const u = new Set(s)
      if (s.has(item)) {
        u.delete(item)
      } else {
        u.add(item)
      }

      return u
    })
  }

  const resetItems = () => setItems(() => getNewSet(initial))
  const isSelected = (item: T): boolean => items.has(item)
  const toArray = (): T[] => [...items]

  return {
    isSelected,
    setItem,
    resetItems,
    toArray,
  }
}
